import { Routes, Route } from 'react-router-dom'

import { AppProvider } from '@!/providers'
import React, { Suspense, lazy } from 'react'
const Announcements = lazy(() => import('@!/Announcements/containers/Announcements'))
const AnnouncementDetail = lazy(() => import('@!/Announcements/containers/AnnouncementDetail'))
import { useAppSettings } from '@!/Hooks/useAppSettings'

const AnnouncementsApp = () => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Announcements />} />
          <Route path="/detail" element={<AnnouncementDetail />} />
          <Route path="/*" element={<Announcements />} />
        </Routes>
      </Suspense>
    </AppProvider>
  )
}

export default AnnouncementsApp
